export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_source_billNo') || '源头单据号',
    field: 'sourceBillNo',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      attrs: {
        maxlength: 50,
      },
      props: {
        clearable: true,
      },
    },
  },

  {
    title: that.$l('table_label_materialNcNo') || '物料编码',
    field: 'materialNcNo',
    align: 'center',
    width: 150,
    editRender: {
      name: 'ElInput',
      attrs: {
        maxlength: 50,
      },
      props: {
        clearable: true,
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_materialName') || '物料名称',
    field: 'materialName',
    headerAlign: 'center',
    align: 'left',
    width: 130,
    editRender: {
      name: 'ElInput',
      attrs: {
        maxlength: 50,
      },
      props: {
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_materialSpec') || '规格型号',
    field: 'materialSpec',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      attrs: {
        maxlength: 50,
      },
      props: {
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_materialColor') || '颜色',
    field: 'materialColor',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      attrs: {
        maxlength: 50,
        placeholder: '请输入颜色',
      },
      props: {
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_wid') || '门幅',
    field: 'wid',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      attrs: {
        maxlength: 200,
        placeholder: '请输入门幅',
      },
      props: {
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_materialUnit') || '单位',
    field: 'materialUnit',
    align: 'center',
    width: 110,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      attrs: {
        maxlength: 50,
        placeholder: '请输入单位',
      },
      props: {
        clearable: true,
      },
    },
  },
  {
    title: that.$l('table_label_qty') || '数量',
    field: 'qty',
    align: 'center',
    width: 115,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 1000000000,
        step: 0.01,
        'controls-position': 'right',
      },
    },
  },
  {
    title: that.$l('table_label_unitPrice') || '单价',
    field: 'unitPrice',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 1000000000,
        step: 0.01,
        'controls-position': 'right',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_costAmount') || '成本费用',
    field: 'costAmount',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_otherAmount') || '异常的额外',
    field: 'otherAmount',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 2,
        min: 0,
        max: 1000000000,
        step: 0.01,
        'controls-position': 'right',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subAmount') || '费用小计',
    field: 'subAmount',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('INDEX.table_label_custOrderNo') || '客户订单号',
    field: 'custOrderNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    editRender: { enable: true },
    slots: { edit: 'custOrderNo' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_custName') || '客户',
    field: 'custName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 250,
  },
]
